export default __webpack_public_path__ + "static/media/BrainBreak cards59.b811ca4f.png";